import {faBox} from "@fortawesome/pro-solid-svg-icons/faBox";
import {faClipboard} from "@fortawesome/pro-solid-svg-icons/faClipboard";
import {faEnvelope} from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import {faFileContract} from "@fortawesome/pro-solid-svg-icons/faFileContract";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useUserAddressDetails, useUserPlanDetails} from "@twigsby/client-data";
import {
    Button,
    Card,
    CardLayoutType,
    ColourSolid, ContentBlock, ContentLoader, FlexAlign,
    FlexGap, FlexJustify,
    StackHorizontal,
    StackVertical, useLayout, useNotifications
} from "@twigsby/frontend-framework";
import React, {useEffect} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const PlanDetails = () => {
    const { t } = useTranslation();
    const { isMedium, isLarge } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();
    const { addNotification } = useNotifications();

    const {
        status: addressStatus,
        data: addressData,
        error: addressError,
    } = useUserAddressDetails();

    const {
        status,
        data,
        error,
    } = useUserPlanDetails();

    const HandleCopy = async (text: string) => {
        addNotification({
            title: t('results.copiedClipboard'),
            icon: faClipboard
        });
        await navigator.clipboard.writeText(text);
    }

    useEffect(() => {
        updatePageMeta({
            title: t('settings.planDetails.title')
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-md'}>
                <h2 className={'mb-0'}>{t('settings.planDetails.title')}</h2>
            </StackHorizontal>

            <StackVertical gap={FlexGap.ExtraLarge}>
                <div>
                    <h6 className={'sub-heading mb-xs'}>{t('settings.planDetails.labels.address')}</h6>
                    <div className={'plan-address-details'}>
                        {addressStatus === "loading" ? (
                            <>
                                <ContentLoader childHeight={'15.8em'} childCount={1} rounded={true} />
                                <ContentLoader childHeight={'15.8em'} childCount={1} rounded={true} />
                                <ContentLoader childHeight={'15.8em'} childCount={1} rounded={true} />
                            </>
                        ) : addressStatus === "error" ? (
                            <ContentBlock error={true} title={addressError.name} content={addressError.message} />
                        ) : (
                            <>
                                {addressData && addressData.manualActions.map((address, index) =>
                                    <div className={`card p-md ${isMedium && !isLarge ? 'flex-column' : 'flex-row' } flex-gap-sm`} key={`preferencesManualAction${index}`} >
                                        <div className={'icon-rounded primary'}>
                                            <FontAwesomeIcon icon={address.label.indexOf('Postal') > -1 ? faEnvelope : faBox} size={"2x"} fixedWidth={true} />
                                        </div>

                                        <div className={'flex-column flex-gap-md'} style={{ justifyContent: 'space-between'}}>
                                            <div>
                                                <h6 className={'mb-xs'}>{address.label.indexOf('Postal') === -1 ? t('settings.planDetails.labels.correspondenceAddress') : t('settings.planDetails.labels.courierPoint')}</h6>
                                                <div className={'mb-xs'}>{address.value}</div>
                                                {address.label.indexOf('Postal') === -1 && (
                                                    <small className={'alert-text'}>{t('settings.planDetails.messages.correspondenceAddress')}</small>
                                                )}
                                            </div>
                                            <StackHorizontal gap={FlexGap.Small}>
                                                <Button title={'Copy'} squared={true} fullWidth={true}  colour={ColourSolid.Primary} onClick={() => HandleCopy(address.value)} />
                                                <Button title={'Share'} squared={true} fullWidth={true}  />
                                            </StackHorizontal>
                                        </div>
                                    </div>
                                )}

                                <div className={`card p-md ${isMedium && !isLarge ? 'flex-column' : 'flex-row'} flex-gap-sm`} >
                                    <div className={'icon-rounded primary'}>
                                        <FontAwesomeIcon icon={faFileContract} size={"2x"} fixedWidth={true} />
                                    </div>

                                    <div className={'flex-column flex-gap-md'} style={{ alignItems: 'flex-start', justifyContent: 'space-between'}}>
                                        <div>
                                            <h6 className={'mb-xs'}>{t('settings.planDetails.labels.virtualOffice')}</h6>
                                            <div>{t('settings.planDetails.messages.virtualOffice')}</div>
                                        </div>
                                        <Button title={'Download'} squared={true} colour={ColourSolid.Primary} fullWidth={true} />
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                </div>

                <div>
                    <Card headerOptions={{title: t('labels.general')}} type={CardLayoutType.SlimHeader} emptyBody={true}>
                        {status === "loading" ? (
                            <ContentLoader childHeight={'6em'} childCount={6} />
                        ) : status === "error" ? (
                            <ContentBlock error={true} title={error.name} content={error.message} />
                        ) : (
                            <>
                                {data && data.manualActions.map((item: any, index) =>
                                    <div className={'user-action'} key={`preferencesManualAction${index}`}>
                                        <div className={'fade'}>{item.label}</div>
                                        <div>{typeof item.value === 'string' ? item.value : item.value.map((entry: any, index: number) => <div key={`settingsEntry${index}`}>{entry}</div>) }</div>
                                    </div>
                                )}
                            </>
                        )}
                    </Card>
                </div>
            </StackVertical>
        </>
    )
}

export default PlanDetails
